import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { isGerman } from '@/i18n/locale';

function getItems() {
  const de = isGerman();
  return [
    {
      to: '/today',
      label: de ? 'Diese Woche' : 'This Week',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        </svg>
      ),
    },
    {
      to: '/chat',
      label: 'Chat',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      ),
    },
    {
      to: '/nutrition',
      label: de ? 'Ernährung' : 'Nutrition',
      // Bowl-of-soup with three steam wisps — reads instantly as food/nutrition.
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 12h16"/>
          <path d="M4 12c0 4.42 3.58 8 8 8s8-3.58 8-8"/>
          <path d="M9 5v-1"/>
          <path d="M12 5v-2"/>
          <path d="M15 5v-1"/>
        </svg>
      ),
    },
    {
      to: '/profile',
      label: de ? 'Profil' : 'Profile',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      ),
    },
  ];
}

export function BottomNav() {
  const { pathname } = useLocation();
  const items = getItems();

  return (
    <nav
      aria-label={isGerman() ? 'Hauptnavigation' : 'Main navigation'}
      className="border-t border-primary-50 bg-cream/95 backdrop-blur supports-[backdrop-filter]:bg-cream/80"
    >
      <div className="mx-auto max-w-chat px-2 pb-[max(env(safe-area-inset-bottom),0.5rem)] pt-1">
        <div className="grid grid-cols-4">
          {items.map((item) => {
            const active = pathname === item.to || pathname.startsWith(item.to + '/');
            return (
              <Link
                key={item.to}
                to={item.to}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'flex flex-col items-center justify-center gap-0.5 py-2 min-h-[48px] rounded-lg transition-colors',
                  active ? 'text-primary-700' : 'text-slate-muted hover:text-slate'
                )}
              >
                <span className={cn('transition-transform', active && 'scale-110')}>
                  {item.icon}
                </span>
                <span className="text-[11px] font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
